import { useQuery } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { createActivationApi } from "app/pages/activation/services/api";

export const SUGGESTIONS_QUERY_KEY = "SUGGESTIONS_TOPICS";

export const useTopicSuggestions = (activationId: string, isEnabled: boolean) => {
    const { showErrorToast } = useToasts();

    return useQuery({
        queryKey: [SUGGESTIONS_QUERY_KEY, activationId],
        queryFn: () => {
            try {
                const api = createActivationApi();

                return api.topics.getSuggestions(activationId);
            } catch (error) {
                showErrorToast(translate("common.api.error", { error: error?.message }));
            }
        },
        staleTime: 0,
        enabled: !!activationId && isEnabled,
    });
};
